"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIVE_DUTY = exports.DISABILITY = exports.INCAPACITY = exports.TEMP_WAIVER = exports.BRIEF_WITHOUT_CERTIFICATE = exports.BRIEF_WITH_CERTIFICATE = void 0; // Status

var BRIEF_WITH_CERTIFICATE = 'brief_with_certificate';
exports.BRIEF_WITH_CERTIFICATE = BRIEF_WITH_CERTIFICATE;
var BRIEF_WITHOUT_CERTIFICATE = 'brief_without_certificate';
exports.BRIEF_WITHOUT_CERTIFICATE = BRIEF_WITHOUT_CERTIFICATE;
var TEMP_WAIVER = 'temp_waiver'; // Status - Exemptions

exports.TEMP_WAIVER = TEMP_WAIVER;
var INCAPACITY = 'incapacity';
exports.INCAPACITY = INCAPACITY;
var DISABILITY = 'disability';
exports.DISABILITY = DISABILITY;
var ACTIVE_DUTY = 'active_duty';
exports.ACTIVE_DUTY = ACTIVE_DUTY;